import { Component, inject, OnInit } from '@angular/core';
import { AppPost } from '../../../models';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ngx-aim-post',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './ngx-aim-post.component.html',
  styleUrl: './ngx-aim-post.component.css'
})
export class NgxAimPostComponent implements OnInit {
  config = inject(DynamicDialogConfig);
  dialogRef = inject(DynamicDialogRef);

  post?: AppPost;

  ngOnInit() {
    this.post = this.config.data.post;
  }

  onCloseClick() {
    this.dialogRef.close();
  }
}
